"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAddress = void 0;
class UserAddress {
    constructor(value) {
        this.value = value;
    }
    bech32() {
        return this.value;
    }
}
exports.UserAddress = UserAddress;
//# sourceMappingURL=userAddress.js.map